const PRICE_SOURCE_BACKEND = 'backend';
const PRICE_SOURCE_ESTIMATED = 'estimated';
const PRICE_SOURCE_CACHE = 'cache';
const PRICE_SOURCE_FREE = 'free';
const PRICE_SOURCE_UNKNOWN = 'unknown';

const TOKENS_PER_MILLION = 1000000;
const DEFAULT_MODEL = 'gpt-5.4-mini';

const MODEL_RATES = {
    'gpt-5.4-mini': {
        input: 0.75,
        cachedInput: 0.075,
        output: 4.5,
    },
    'gpt-4o-mini': {
        input: 0.15,
        cachedInput: 0.075,
        output: 0.6,
    },
    'gpt-4.1-nano': {
        input: 0.1,
        cachedInput: 0.025,
        output: 0.4,
    },
    'gpt-4.1-mini': {
        input: 0.4,
        cachedInput: 0.1,
        output: 1.6,
    },
    'gpt-4o': {
        input: 2.5,
        cachedInput: 1.25,
        output: 10,
    },
};

const toNumber = (value) => {
    if (value === null || value === undefined || value === '')
    {
        return null;
    }

    const number = Number(value);

    return Number.isFinite(number) ? number : null;
};

const getModelRates = (model) => {
    const normalizedModel = String(model || DEFAULT_MODEL).trim().toLowerCase();

    if (!normalizedModel)
    {
        return null;
    }

    const match = Object.keys(MODEL_RATES).find((modelName) =>
        normalizedModel === modelName ||
        normalizedModel.startsWith(`${ modelName }-`)
    );

    return match ? MODEL_RATES[ match ] : null;
};

const hasTokenUsage = (record) => (
    (toNumber(record?.prompt_tokens) || 0) > 0 ||
    (toNumber(record?.completion_tokens) || 0) > 0 ||
    (toNumber(record?.total_tokens) || 0) > 0
);

const isCacheOnly = (record) => {
    const itemsCount = toNumber(record?.items_count) || 0;
    const cacheHits = toNumber(record?.cache_hit_items_count) || 0;

    return itemsCount > 0 && cacheHits >= itemsCount && !hasTokenUsage(record);
};

const calculateEstimatedPrice = (record) => {
    const rates = getModelRates(record?.model);

    if (!rates || !hasTokenUsage(record))
    {
        return null;
    }

    const promptTokens = toNumber(record?.prompt_tokens) || 0;
    const completionTokens = toNumber(record?.completion_tokens) || 0;

    return (
        (promptTokens * rates.input) +
        (completionTokens * rates.output)
    ) / TOKENS_PER_MILLION;
};

const resolvePrice = (record, field = 'total_tokens_price') => {
    const backendPrice = toNumber(record?.[ field ]);

    if (backendPrice && backendPrice > 0)
    {
        return {
            value: backendPrice,
            source: PRICE_SOURCE_BACKEND,
        };
    }

    const estimatedPrice = calculateEstimatedPrice(record);

    if (estimatedPrice && estimatedPrice > 0)
    {
        return {
            value: estimatedPrice,
            source: PRICE_SOURCE_ESTIMATED,
        };
    }

    if (isCacheOnly(record))
    {
        return {
            value: 0,
            source: PRICE_SOURCE_CACHE,
        };
    }

    if (backendPrice === 0 && !hasTokenUsage(record))
    {
        return {
            value: 0,
            source: PRICE_SOURCE_FREE,
        };
    }

    return {
        value: null,
        source: PRICE_SOURCE_UNKNOWN,
    };
};

const TranslationAiPricingHelper = {
    PRICE_SOURCE_BACKEND,
    PRICE_SOURCE_ESTIMATED,
    PRICE_SOURCE_CACHE,
    PRICE_SOURCE_FREE,
    PRICE_SOURCE_UNKNOWN,
    DEFAULT_MODEL,
    resolvePrice,
};

export default TranslationAiPricingHelper;
